const lineBreak = `
`

//Data for Guide sheet
export const BULK_TEXT_FOR_UPLOAD = {
  EXPORT: {
    INSTRUCTION: {
      HEADING: 'Quick Guide to Upload Item Data',
      SUB_HEADING1: 'Overview',
      LINE1: `
Use this guide to set up or maintain item data using the provided template. Follow the instructions carefully to ensure your file is processed successfully and without delays.`,
      LINE1_1: `This version of the template includes attributes from LaunchPad, Compliance, and Pricing.`,
      LINE1_2: `This template is specific to the selected [Item Type] and does not include all attributes required for LP Vendor Complete status. Some optional attributes are currently out of scope for Bulk Upload. Any missing attributes should be filled  directly in their respective systems. All these systems are available on ItemHub.`,
      LINE2: `File Structure:${lineBreak}`,
      LINE2_1: `Guide (this sheet): `,
      LINE2_2: `Explains the usage of the template and provides instructions to enter item data.${lineBreak}`,
      LINE2_3: `Item Type: `,
      LINE2_4: `Use this template to enter item data. Do not modify columns or delete rows 1–5.${lineBreak}`,
      LINE2_5: `Multi-values Reference: `,
      LINE2_6: `This sheet provides a list of Target approved selections for multi-value attributes in the template.${lineBreak}`,
      LINE2_7: `Note: Some required fields cannot be edited through the bulk upload file. If any of the following values are missing for your items, add them in LaunchPad before downloading the template:${lineBreak} Barcode, Primary Barcode, Return Policy, Primary Return Policy`,
      SUB_HEADING2: 'Data Entry',
      LINE3:
        'Go to the "Item Type" sheet. Enter the required values for each attribute as per the specifications.',
      LINE4: `File Preparation:`,
      LINE5: 'Preserve Rows 1-5: ',
      LINE5_1: 'Do not modify these rows; they contain essential metadata.',
      LINE6: 'Do Not Change Column Order: ',
      LINE6_1:
        'Adding, deleting, or reordering columns will cause file processing errors.',
      LINE7: 'Entering Data:',
      LINE8: 'Column-Specific Guidelines:',
      LINE9: 'Blue (Required): ',
      LINE9_1:
        'Required to complete item setup in LaunchPad, Compliance & Pricing. Partial required attribute submissions will still process; only provided fields are validated and updated.',
      LINE10: 'Purple (Conditionally Required): ',
      LINE10_1: 'Fill only if the specified condition applies.',
      LINE11: 'White (Optional): ',
      LINE11_1: 'Fill if applicable; improves item findability on Target.com.',
      LINE12: 'Grey (Do Not Edit): ',
      LINE12_1: `These are Target-entered values provided for reference. Do not manually add new items or modify values in these fields. Any updates will be ignored by LaunchPad, and removing values (e.g., Barcode) ${lineBreak} will prevent items from being processed.`,
      LINE13: 'Validation:',
      LINE14:
        'Use only valid dropdown values. Incorrect entries may lead to file rejection.',
      LINE15: `For free-text fields accepting multiple values, refer to the 'Multi-values Reference' sheet and enter one or more approved values separated by pipe '|'.`,
      LINE16: `Files will not be rejected for missing required attributes. Only submitted fields are validated and updated.`,

      LINE17: 'Data Formatting:',
      LINE18: 'Copy-Pasting Data: ',
      LINE18_1: `Use 'Special Paste > Values' if copying data from another source to avoid formatting errors.`,
      LINE19: 'File Name: ',
      LINE19_1: `Do not alter the file name before uploading.`,
      LINE20: 'File Size Limit: ',
      LINE20_1: `The file size must not exceed 10 MB and cannot exceed 10,000 rows.`,
      LINE21: 'File Type: ',
      LINE21_1: `Acceptable formats are .csv, .xls and .xlsx only.`,
      SUB_HEADING3: 'Uploading Your File',
      LINE22: 'Save your file: ',
      LINE22_1: `Save the file in supported format.`,
      LINE23: 'Upload: ',
      LINE23_1: `Use the ‘Upload spreadsheet’ section in LaunchPad.`,
      LINE24: 'Processing: ',
      LINE24_1: `A new request will appear in the ‘Upload History’. Processing time depends on file size.`,
      LINE25: 'Review: ',
      LINE25_1: `Once file status shows 'Processed', check the ‘Item Validation status’ for approved vs. rejected records.`,
      LINE26: 'Processing Failed: ',
      LINE26_1: `If file processing fails, click on the help icon to view process error details and resolve accordingly.`,
      SUB_HEADING4: 'Handling Errors and Re-uploading',
      LINE27: `Error Stages:`,
      LINE27_1: `Target performs validation in 3 stages:`,
      LINE29: `Template validation: `,
      LINE29_1: `Validates file structure, formatting, and required identifiers (including Barcode and Primary Barcode).`,
      LINE30: `Data Quality check: `,
      LINE30_1: `Validates attribute values against data quality rules.`,
      LINE31: `This breakdown is provided for transparency. Ensure all required data is complete and accurate before uploading the file.`,
      LINE32: `Error Report:`,
      LINE32_1: `If your file fails in any of the 3 stages, an Error Report will be generated in the Upload History section.`,
      LINE33: `Download the rejected items file.`,
      LINE34: `The file includes error counts and messages in Columns D and E`,
      LINE35: `Resolution`,
      LINE36: `Follow the error message in each row and update the corresponding cell values.`,
      LINE37: `Correct the errors in the same file and re-upload until all items pass validation.`,
      LINE38: `Post-Validation:`,
      LINE39: `Once data validation is successful, complete any additional attributes directly in LaunchPad to achieve LP Vendor Complete status.`,
      LINE40: `Post-Validation:`,
      LINE41: `After all items are successfully validated, ensure additional required attributes are completed in LaunchPad to achieve LP Vendor Complete status.${lineBreak}Complete any remaining optional attributes directly in their respective systems.`,
      SUB_HEADING5: 'Additional Support',
      LINE42: `For further support, please submit a ticket through the 'Need Help' section on the LaunchPad homepage.`,
    },
    DATATEXT: {
      NOTE1:
        'The top 6 rows are for Target use only. Do not modify or delete the top 6 rows.',
      NOTE2:
        'NOTE: This sheet is designed for audit purpose only. DO NOT use this sheet to edit/upload data on the tool',
    },
    ROWHEAD: {
      GROUP: 'Category',
      ATTR_GROUP: 'Sub-Category',
      ATTR: 'Attribute',
    },
  },
}

//Data for Valid options sheet
export const BULK_TEXT_FOR_VALID_OPTIONS = {
  EXPORT: {
    HINT_TEXT: `For columns that accept multiple values (indicated in the column header), select one or more valid options from the list below and enter them in the template, separated by pipe '|'.`,
    HEADING: {
      HEADING_1: 'Attribute Name',
      HEADING_2: 'Valid Options',
    },
  },
}

/** Styles **/

// 1.2 SubCategory Headers Fill
export const goldBgSubCategoryHeadersFill = {
  fill: { fgColor: { argb: 'FEBA17' }, bgColor: { argb: 'FEBA17' } },
}
export const blueBgSubCategoryHeadersFill = {
  fill: { fgColor: { argb: 'BBCCEF' }, bgColor: { argb: 'BBCCEF' } },
}
export const errorSubCategoryHeadersFill = {
  fill: { fgColor: { argb: 'EF9A9A' }, bgColor: { argb: 'EF9A9A' } },
}

// 2.2 Attribute Headers Fill
export const greyAttributeHeadersFill = {
  fill: { fgColor: { argb: 'E5E1DA' }, bgColor: { argb: 'E5E1DA' } },
}
export const blueAttributeHeadersFill = {
  fill: { fgColor: { argb: 'E3F2FD' }, bgColor: { argb: 'E3F2FD' } },
}
export const purpleAttributeHeadersFill = {
  fill: { fgColor: { argb: 'DFE2F7' }, bgColor: { argb: 'DFE2F7' } },
}
export const redAttributeHeadersFill = {
  fill: { fgColor: { argb: 'FCE4EC' }, bgColor: { argb: 'FCE4EC' } },
}

// 3.2 Field modes Fill
export const requiredFieldFill = {
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'E3F2FD' },
    bgColor: { argb: 'E3F2FD' },
  },
}
export const optionalFieldFill = {
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: undefined },
    bgColor: { argb: undefined },
  },
}
export const nonEditableFieldsFill = {
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'E5E1DA' },
    bgColor: { argb: 'E5E1DA' },
  },
}
export const conditionallyRequiredFieldsFill = {
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'DFE2F7' },
    bgColor: { argb: 'DFE2F7' },
  },
}

export const tabColorStyle = ['faa21d', '85d2ed', '1976D2']
export const InstructionSheetStyle = {
  header: {
    font: {
      size: 18,
      bold: true,
    },
  },
  exportTitle: {
    font: {
      color: { argb: 'FFFFFF' },
      size: 14,
      bold: false,
    },
    fill: {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCA1C1C' },
    },
  },
  text: {
    font: {
      size: 10,
      bold: false,
      name: 'Helvetica Light',
    },
    alignment: {
      warpText: true,
    },
  },
  subheading: {
    fill: {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D3D3D3' },
      bgColor: { argb: 'D3D3D3' },
    },
  },
}

export const optionsSheetStyle = {
  header: {
    font: {
      color: { argb: 'FFFFFF' },
      size: 12,
      bold: false,
    },
    fill: {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '29465B' },
    },
  },
}

export const alignCenter = {
  horizontal: 'center',
  vertical: 'middle',
}

export const boldItalic = {
  bold: true,
  italic: true,
}

export const italic = {
  italic: true,
}

export const wrapText = { wrapText: true }

export const base64Image =
  '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'
